// extracted by mini-css-extract-plugin
export default {"TruckHero":"TABugv9ZyIe0bsSmQizJ","TruckHero_slider":"RRybgjkBDKknQuFhQohr","TruckHero_slide":"XD4xeKb8Xcbgs4f4374s","TruckHero_img":"HTEdbXuhekc5V0fcg6h3"};